export default __webpack_public_path__ + "static/media/RobotoMono-Regular.533aba00.woff";